import { makeJsonRequest } from '../ajax';

export default function articleName({ csrfToken, name, urlForSave }) {
  return {
    editing: false,
    name,
    savedName: name,

    async reset() {
      this.name = this.savedName;
      this.editing = false;
    },

    startEditing() {
      this.editing = true;
      this.$nextTick(() => { this.$refs.input.focus(); });
    },

    async save() {

      return makeJsonRequest({
        url: urlForSave,
        method: 'PATCH',
        bodyData: { csrfToken, name: this.name },
        onSuccess: (responseBodyData) => {
          this.savedName = this.name = responseBodyData.name;
        },
        onError: (statusCode, responseBodyData, errorMessage) => {
          this.name = this.savedName;
        },
        onDone: () => {
          this.editing = false;
        },
      });
    },
  }
}
